var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProiseek = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.59,
    height: 79.19,
    viewBox: "0 0 114.59 79.19",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b3d45f;\n      }\n\n      .cls-2 {\n        fill: #9bc83a;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        stroke: #40535e;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        fill: #f2f2b4;\n      }\n\n      .cls-5 {\n        fill: #96c54d;\n      }\n\n      .cls-6 {\n        fill: #7ba640;\n      }\n\n      .cls-7 {\n        fill: #f7981d;\n      }\n\n      .cls-8 {\n        fill: #cadc6f;\n      }\n\n      .cls-9 {\n        fill: #363d3f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 59.59,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 24.19,
    width: 55,
    height: 55,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.59,
    y: 9.5,
    width: 97,
    height: 62,
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iseek_logo_brand-colors-2018"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 73.59,
    y: 44.16,
    width: 3.23,
    height: 3.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.53,44.96v-5.53c0-.64-.14-1.16-.43-1.55-.29-.39-.66-.7-1.11-.92-.45-.22-.95-.37-1.5-.44-.55-.07-1.09-.11-1.62-.11-.59,0-1.18,.06-1.76,.17-.58,.12-1.11,.31-1.57,.59-.47,.27-.85,.64-1.15,1.09-.3,.45-.47,1.02-.51,1.71h0s2.92,0,2.92,0c.05-.58,.25-.99,.58-1.23,.33-.25,.78-.37,1.36-.37,.26,0,.5,.02,.73,.05,.23,.03,.42,.1,.6,.21,.17,.1,.31,.25,.41,.43,.1,.19,.15,.44,.15,.75,.01,.3-.08,.53-.27,.69-.19,.16-.45,.28-.78,.36-.33,.08-.71,.14-1.13,.18-.43,.04-.86,.1-1.3,.16-.44,.07-.87,.16-1.31,.28-.43,.12-.82,.29-1.15,.52-.34,.23-.61,.55-.82,.94-.21,.39-.32,.89-.32,1.49,0,.55,.09,1.02,.28,1.42,.18,.4,.44,.73,.77,.99,.33,.26,.71,.45,1.15,.58,.44,.12,.91,.18,1.42,.18,.66,0,1.3-.1,1.93-.29,.63-.19,1.18-.53,1.65-1.01,.01,.18,.04,.35,.07,.52,.03,.17,.08,.34,.13,.5h2.96c-.14-.22-.23-.55-.29-.99-.06-.44-.08-.9-.08-1.38Zm-2.97-1.09c-.03,.27-.13,.55-.28,.81-.15,.27-.38,.5-.7,.69-.32,.19-.76,.29-1.34,.29-.23,0-.46-.02-.68-.06-.22-.04-.41-.11-.58-.22-.16-.1-.29-.24-.39-.42-.1-.18-.14-.4-.14-.66,0-.27,.05-.5,.14-.68,.1-.18,.22-.33,.38-.44,.16-.12,.34-.21,.56-.28,.21-.07,.43-.12,.65-.16,.23-.04,.47-.08,.7-.1,.23-.03,.46-.06,.67-.1,.21-.04,.41-.09,.6-.15,.18-.06,.34-.15,.46-.26v1.09c0,.16-.02,.38-.05,.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 91.88,
    y: 36.7,
    width: 2.92,
    height: 10.63
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.41,40.02c-.19-.75-.5-1.42-.93-2.01-.43-.59-.98-1.06-1.65-1.4-.67-.35-1.45-.52-2.36-.52-.81,0-1.54,.14-2.2,.43-.66,.29-1.23,.68-1.71,1.18-.48,.5-.85,1.09-1.11,1.77-.26,.68-.39,1.42-.39,2.21s.13,1.57,.38,2.25c.25,.68,.61,1.27,1.08,1.76,.46,.49,1.03,.87,1.7,1.14,.67,.27,1.42,.4,2.25,.4,1.2,0,2.23-.27,3.07-.82,.85-.55,1.47-1.46,1.88-2.73h-2.56c-.1,.33-.36,.64-.78,.93-.42,.29-.93,.44-1.52,.44-.82,0-1.45-.21-1.88-.64-.44-.42-.68-1.11-.72-2.05h7.64c.05-.82-.01-1.6-.2-2.36Zm-7.44,.51c.01-.2,.06-.44,.13-.7,.08-.26,.2-.51,.39-.74,.18-.23,.43-.43,.74-.58,.31-.16,.69-.24,1.16-.24,.71,0,1.24,.19,1.59,.57,.35,.38,.59,.94,.73,1.68h-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.17,40.02c-.19-.75-.5-1.42-.93-2.01-.43-.59-.98-1.06-1.65-1.4-.67-.35-1.45-.52-2.36-.52-.81,0-1.54,.14-2.2,.43-.66,.29-1.23,.68-1.71,1.18-.48,.5-.85,1.09-1.11,1.77-.26,.68-.39,1.42-.39,2.21s.13,1.57,.38,2.25c.25,.68,.61,1.27,1.08,1.76,.46,.49,1.03,.87,1.7,1.14,.67,.27,1.42,.4,2.25,.4,1.2,0,2.23-.27,3.07-.82,.85-.55,1.48-1.46,1.88-2.73h-2.56c-.1,.33-.36,.64-.78,.93-.42,.29-.93,.44-1.52,.44-.82,0-1.45-.21-1.88-.64-.44-.42-.68-1.11-.72-2.05h7.64c.05-.82-.01-1.6-.2-2.36Zm-7.44,.51c.01-.2,.06-.44,.13-.7,.08-.26,.2-.51,.39-.74,.18-.23,.43-.43,.74-.58,.31-.16,.69-.24,1.16-.24,.71,0,1.24,.19,1.59,.57,.35,.38,.59,.94,.73,1.68h-4.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "66.38 40.27 70.37 36.38 66.93 36.38 63.27 40.19 63.27 32.34 60.36 32.34 60.36 46.97 63.27 46.97 63.27 43.32 64.39 42.24 67.3 46.97 70.83 46.97 66.38 40.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 19.78,
    y: 36.25,
    width: 2.93,
    height: 11.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.77,41.47c-.31-.23-.67-.41-1.08-.54-.4-.14-.82-.25-1.24-.35-.41-.1-.81-.18-1.21-.27-.4-.08-.75-.17-1.05-.28-.31-.1-.56-.24-.75-.4-.19-.16-.29-.38-.29-.64,0-.22,.05-.39,.16-.52,.11-.13,.24-.23,.4-.3,.16-.07,.33-.11,.52-.13,.19-.02,.37-.03,.53-.03,.52,0,.97,.1,1.35,.3,.38,.2,.59,.58,.64,1.14h2.77c-.05-.66-.22-1.2-.5-1.63-.28-.43-.63-.78-1.06-1.03-.42-.26-.91-.44-1.44-.55-.54-.11-1.1-.16-1.67-.16s-1.13,.05-1.68,.15c-.55,.1-1.04,.28-1.48,.53-.44,.25-.79,.6-1.05,1.03-.27,.44-.4,1-.4,1.68,0,.46,.1,.86,.29,1.18,.19,.32,.44,.59,.76,.8,.31,.21,.67,.38,1.08,.51,.4,.13,.82,.24,1.24,.34,1.04,.22,1.85,.44,2.43,.66,.58,.22,.87,.55,.87,.98,0,.26-.06,.48-.18,.65-.12,.17-.28,.31-.46,.41-.18,.1-.39,.18-.61,.22-.23,.05-.44,.07-.65,.07-.29,0-.56-.03-.83-.1-.27-.07-.5-.17-.71-.32-.21-.14-.37-.33-.5-.55-.13-.23-.19-.5-.19-.81h-2.77c.03,.71,.19,1.3,.48,1.77,.29,.47,.67,.85,1.13,1.14,.46,.29,.98,.49,1.57,.61,.59,.12,1.19,.18,1.8,.18s1.19-.06,1.77-.17c.58-.12,1.1-.32,1.55-.61,.45-.29,.82-.66,1.1-1.14,.28-.47,.42-1.05,.42-1.75,0-.49-.1-.9-.29-1.24-.19-.33-.44-.61-.76-.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23.22,33.57c0,1.1-.88,1.99-1.98,1.99-1.09,0-1.99-.88-1.99-1.98,0-1.1,.88-1.99,1.98-1.99,1.1,0,1.98,.88,1.99,1.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.82,33.97c0,.88-.71,1.59-1.58,1.59-.88,0-1.59-.71-1.59-1.58,0-.88,.71-1.59,1.58-1.59,.88,0,1.59,.71,1.59,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.43,34.37c0,.66-.53,1.19-1.19,1.19-.66,0-1.19-.53-1.19-1.19,0-.66,.53-1.19,1.19-1.19,.66,0,1.19,.53,1.19,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.03,34.77c0,.44-.35,.79-.79,.8-.44,0-.79-.35-.8-.79,0-.44,.35-.8,.79-.8,.44,0,.79,.35,.8,.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.63,35.16c0,.22-.18,.4-.39,.4-.22,0-.4-.18-.4-.4,0-.22,.18-.4,.4-.4,.22,0,.4,.18,.4,.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.33,33.57c0,1.1-.88,1.99-1.98,1.99-1.1,0-1.99-.88-1.99-1.98,0-1.1,.88-1.99,1.98-1.99,1.1,0,1.98,.88,1.99,1.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.93,33.97c0,.88-.71,1.59-1.58,1.59-.87,0-1.59-.71-1.59-1.58,0-.88,.71-1.59,1.58-1.59,.88,0,1.59,.71,1.59,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.54,34.37c0,.66-.53,1.19-1.19,1.19-.66,0-1.19-.53-1.19-1.19,0-.66,.53-1.19,1.19-1.19,.66,0,1.19,.53,1.19,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M94.14,34.77c0,.44-.35,.79-.79,.8-.44,0-.79-.35-.8-.79,0-.44,.35-.8,.79-.8,.44,0,.79,.35,.8,.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.75,35.16c0,.22-.18,.4-.4,.4-.22,0-.4-.18-.4-.4,0-.22,.18-.4,.4-.4,.22,0,.4,.18,.4,.4"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProiseek);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pro.iseek.316695a81d37b4dfc1a5200daddc0f23.svg";